export const ICOUNT_COMPLOG_PRINTEAM_PAGE = Object.freeze({
  origin: 'https://app.icount.co.il',
  pathname: '/m/c4a5e',
  pageId: '10',
});

function cleanText(value) {
  return String(value || '').trim();
}

export function buildIcountComplogCheckoutUrl({
  amount,
  idempotencyKey,
  description,
  name,
  email,
  phone,
  successUrl,
  failureUrl,
  cancelUrl,
} = {}) {
  const numericAmount = Number(amount);
  const normalizedIdempotencyKey = cleanText(idempotencyKey);
  if (!Number.isFinite(numericAmount) || numericAmount <= 0) {
    throw new Error('invalid_icount_amount');
  }
  if (normalizedIdempotencyKey.length < 6) {
    throw new Error('invalid_icount_idempotency_key');
  }

  const url = new URL(
    ICOUNT_COMPLOG_PRINTEAM_PAGE.pathname,
    ICOUNT_COMPLOG_PRINTEAM_PAGE.origin,
  );
  const amountText = String(numericAmount);
  url.searchParams.set('sum', amountText);
  url.searchParams.set('cs', amountText);
  url.searchParams.set('utm_nooverride', '1');
  url.searchParams.set('m__idem', normalizedIdempotencyKey);

  const optionalValues = [
    ['cd', description],
    ['full_name', name],
    ['contact_email', email],
    ['contact_phone', phone],
    ['success_url', successUrl],
    ['failure_url', failureUrl],
    ['cancel_url', cancelUrl],
  ];
  optionalValues.forEach(([key, value]) => {
    const normalized = cleanText(value);
    if (normalized) url.searchParams.set(key, normalized);
  });

  return url;
}
